import { render, staticRenderFns } from "./CeldaHtmlEditor.vue?vue&type=template&id=156f13e9&scoped=true"
import script from "./CeldaHtmlEditor.vue?vue&type=script&lang=js"
export * from "./CeldaHtmlEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f13e9",
  null
  
)

export default component.exports